"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@material-ui/core/styles");
var FlexibleBar_1 = __importDefault(require("./widgets/DeviceStatistics/FlexibleBar"));
var DeviceLegend_1 = __importDefault(require("./widgets/DeviceStatistics/DeviceLegend"));
var BaseStatisticsLayout_1 = __importDefault(require("./BaseStatisticsLayout"));
/**
 * Calculate a percentage with rounded one dp.
 *
 * @param count The count of the portion.
 * @param total The sum of all counts in all portions.
 */
function getFormattedPercent(count, total) {
    var percent = (count * 100) / total;
    return Math.round(percent * 10) / 10;
}
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        devicesRoot: {
            display: 'flex',
            height: 30,
            borderRadius: 30,
            width: '100%',
            overflow: 'hidden',
        },
        legendRoot: (_a = {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 20
            },
            _a[theme.breakpoints.up('sm')] = {
                justifyContent: 'unset',
            },
            _a),
        legend: (_b = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            _b[theme.breakpoints.up('sm')] = {
                marginRight: 40,
                alignItems: 'unset',
                '&:last-child': {
                    marginRight: 0,
                },
            },
            _b),
    });
});
function DeviceStatistics(_a) {
    var deviceClicks = _a.deviceClicks;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    /**
     * Process device clicks data by adding in labels and relevant color codes.
     *
     * @param data The device clicks data to be processed.
     */
    function processStatistics(data) {
        return [
            {
                label: t('editLink.analytics.devices.desktop'),
                count: data.desktop,
                color: '#F3B600',
            },
            {
                label: t('editLink.analytics.devices.tablet'),
                count: data.tablet,
                color: '#2E2E2E',
            },
            {
                label: t('editLink.analytics.devices.mobile'),
                count: data.mobile,
                color: '#818181',
            },
            {
                label: t('editLink.analytics.devices.others'),
                count: data.others,
                color: '#C8C8C8',
            },
        ];
    }
    var processedDeviceClicks = processStatistics(deviceClicks);
    var totalClicks = processedDeviceClicks
        .map(function (clicks) { return clicks.count; })
        .reduce(function (x, y) { return x + y; }, 0);
    return (react_1.default.createElement(BaseStatisticsLayout_1.default, { title: t('editLink.analytics.devices.question') },
        react_1.default.createElement("div", { className: classes.legendRoot }, processedDeviceClicks.map(function (clicks) {
            var percent = getFormattedPercent(clicks.count, totalClicks);
            return (react_1.default.createElement(DeviceLegend_1.default, { key: clicks.label, className: classes.legend, percent: percent, dotColor: clicks.color, label: clicks.label }));
        })),
        react_1.default.createElement("div", { className: classes.devicesRoot }, processedDeviceClicks.map(function (clicks) { return (react_1.default.createElement(FlexibleBar_1.default, { label: clicks.label, count: clicks.count, color: clicks.color })); }))));
}
exports.default = DeviceStatistics;
